<template>
  <CollectionCard>
    <CollectionCardImage :image="item.image">
      <template #back>
        <div class="collection-card-utility-description">
          {{ item.description }}
        </div>
      </template>
    </CollectionCardImage>
    <CollectionCardHeader
      name="Breeding Replenishment"
      :guild="item.guild"
    />

    <CollectionCardActions
      :items="actions"
      @replenishBreed="replenishBreed"
    />
  </CollectionCard>
</template>
<script>
import { computed, defineComponent } from "vue";
import CollectionCardHeader from "../CollectionCard/CollectionCardHeader.vue";
import { TokenType } from "@/config/token-types";
import CollectionCard from "../CollectionCard/CollectionCard.vue";
import CollectionCardImage from "../CollectionCard/CollectionCardImage.vue";
import CollectionCardActions from "../CollectionCard/CollectionCardActions.vue";
import { useWeb3Store } from "@/store/web3";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { CollectionLayouts, useCollectionLayout } from "../useCollectionLayout";
import { replenishBreeding } from "@/functions/replenishBreeding";

export default defineComponent({
  components: { CollectionCardActions, CollectionCardImage, CollectionCardHeader, CollectionCard },
  props: {
    item: Object,
  },
  setup(props) {
    const walletCollectionStore = useWalletCollectionStore()
    const actions = computed(() => {
      return [
        {
          name: "Replenish Breed",
          event: "replenishBreed",
          disabled: walletCollectionStore.genesis.findIndex(bull => bull.guild === props.item.guild && bull.breedingsLeft <= 0) < 0
        }
      ]
    })
    const replenishBreed = () => {
      useCollectionLayout().switchCollectionLayout(CollectionLayouts.select, {
        filter: (token, selection) => {
          if (token.type !== TokenType.GENESIS) return false
          if (token.breedingsLeft > 0) return false
          if (token.guild !== props.item.guild) return false
          return true
        },
        selectLimit: 1,
        actionText: (selection) => {
          return `Bull ${selection[0] ? selection[0].id : '?'} is selected to replenish breed`
        },
        canApprove: (selection) => selection.length > 0,
        onApprove: (selection) => {
          return replenishBreeding(selection[0], props.item.id)
        }
      })
    }
    return { TokenType, actions, replenishBreed }
  }
})
</script>
<style lang="scss">
</style>